module.exports = __webpack_public_path__ + "img/icon1.a5bd519e.png";